import { get } from 'lodash';

import { Alias } from './alias-data-store';

export const translatedTitle = (alias: Alias) => get(alias, 'translatedTitle');
